/**
 * @generated SignedSource<<39dbdef8bdb7f41bffa44ac377361d6b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddTeamMemberForm_team$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"RoleSelectWithPortfolioOrProject_team">;
  readonly " $fragmentType": "AddTeamMemberForm_team";
};
export type AddTeamMemberForm_team$key = {
  readonly " $data"?: AddTeamMemberForm_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddTeamMemberForm_team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddTeamMemberForm_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoleSelectWithPortfolioOrProject_team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "3283638df11933220995a0fff855585b";

export default node;
